export const CLOUDINARY_CONFIG = {
  cloudName: 'dfnmzdk1q',
  uploadPreset: 'iyanna_uploads',
};

export async function uploadToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_CONFIG.uploadPreset);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/image/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );
  const data = await response.json();
  return data.secure_url;
}

export async function uploadDocumentToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_CONFIG.uploadPreset);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/raw/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );
  const data = await response.json();
  return data.secure_url;
}

export async function uploadCertificateToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_CONFIG.uploadPreset);

  // Try image upload first then raw for PDFs
  const isImage = file.type.startsWith('image/');
  const endpoint = isImage ? 'image' : 'raw';

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/${endpoint}/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );
  const data = await response.json();
  return data.secure_url;
}